/**
 * Messages module translations
 * Shared namespace for Messages feature across all products
 */

import pages from "./pages";
import tabs from "./tabs";
import buttons from "./buttons";
import labels from "./labels";
import emptyStates from "./emptyStates";
import table from "./table";
import statuses from "./statuses";

const messages = {
  pages,
  tabs,
  buttons,
  labels,
  emptyStates,
  table,
  statuses,
};

export default messages;
